<template>
    <DataTable :loading="!header" :value="dataArray" responsiveLayout="scroll"
        class="p-datatable-sm editable-cells-table" :rowClass="hideRow">
        <Column>
            <template #header="">
                <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm" @click="addDetail"
                    :disabled="!canEdit" />
            </template>
            <template #body="slotProps">
                <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm" @click="deleteDetail(slotProps)"
                    :disabled="!canEdit" />
            </template>
        </Column>
        <Column field="Status" :header="$t('status')" key="Status">
            <template #body="slotProps">
                <InputText name="Status" v-model="slotProps.data[slotProps.column.props.field]" type="text"
                    :placeholder="$t('status')" :disabled="true" @change="onCellEditComplete(slotProps)" />
            </template>
        </Column>
        <Column field="VendorId" :header="$t('company')" key="VendorId">
            <template #body="slotProps">
                <CustomSelect v-model="slotProps.data[slotProps.column.props.field]"
                    :url="$API_URL + 'list/companylinked_id'" :minLength="0" :filter="true"
                    @change="onCellEditComplete(slotProps); companychange(slotProps, $event)"
                    :disabled="!canEdit || slotProps.data.Status != this.$APPROVAL_STATUS.NEW"
                    :params="{ companyId: header.Id }" />
            </template>
        </Column>
        <Column field="tempArrSuspend" :header="$t('department')" key="tempArrSuspend">
            <template #body="slotProps">
                <CustomMultiSelectV2 v-model="slotProps.data[slotProps.column.props.field]"
                    :url="$API_URL + 'list/suspendeddept'" :minLength="0" :filter="true"
                    @change="onCellEditComplete(slotProps); changedept(slotProps, $event)" placeholder="Please Select"
                    :disabled="!canEdit || slotProps.data.Status != this.$APPROVAL_STATUS.NEW"
                    :params="{ companyCode: this.companyCode }" />
            </template>
        </Column>
        <Column field="Remark" :header="$t('remark')" key="Remark">
            <template #body="slotProps">
                <InputText name="Remark" v-model="slotProps.data[slotProps.column.props.field]" type="text"
                    :placeholder="$t('remark')"
                    :disabled="!canEdit || slotProps.data.Status != this.$APPROVAL_STATUS.NEW"
                    @change="onCellEditComplete(slotProps)" />
            </template>
        </Column>
    </DataTable>
</template>
<script>
export default {
    props: {
        dataArray: {
            type: Array,
            default: []
        },
        dataModel: {
            type: Object,
            default: []
        },
        mode: {
            type: String,
            default: ""
        },
        header: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            companyCode: this.$store.getters.getCompanyCode,
        }
    },
    methods: {
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        addDetail() {
            var newDetail = this.dataModel;
            newDetail.mode = this.$FORM_MODE_CREATE;
            newDetail.Status = this.$APPROVAL_STATUS.NEW;
            newDetail.VendorId = null;


            var det = { ...newDetail };


            this.dataArray.push(det);
        },
        deleteDetail(event) {
            if (event) {
                var detail = this.dataArray[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.dataArray.splice(this.dataArray.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditComplete(event) {
            this.editDetail(event.index);
        },
        editDetail(index) {
            if (this.dataArray && this.dataArray.length > 0) {
                let m = this.dataArray[index].mode;
                if (m == this.$FORM_MODE_UNCHANGED) {
                    this.dataArray[index].mode = this.$FORM_MODE_EDIT;

                }
            }
        },
        companychange(event, e) {
            if (this.dataArray && this.dataArray.length > 0) {
                this.dataArray[event.index].companycode = e == null ? "" : e.code;
                this.dataArray[event.index].VendorId = e == null ? "" : e.id;
            }
        },
        changedept(event, e) {
            if (this.dataArray && this.dataArray.length > 0) {
                this.dataArray[event.index].tempArrSuspend = e == null ? [] : e;
                this.dataArray[event.index].DeptId = this.dataArray[event.index].tempArrSuspend.map(a => a.id);
            }
        }
    },
    computed: {
        canEdit() {
            return this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT;
        }
    }
}
</script>